import React from "react";
import myLogo from "../../assets/images/kenchi_logo.png";
import myCV from "../../assets/resume.pdf";

import "./header.css";
import { StyledSectionContainer } from "../layout/Layout";

const Header = () => {
  // useEffect(() => {
  //   AOS.init({
  //     offset: 100,
  //     duration: 400,
  //     easing: "ease-in-sine",
  //     delay: 100,
  //     once: true,
  //   });
  // });

  const handleClick = () => {
    window.open(
      "https://www.linkedin.com/in/simeonkenneth",
      "_blank",
      "resizable=yes,scrollbars=yes,status=yes"
    );
  };
  return (
    <div className={"header-banner"}>
      <StyledSectionContainer>
        <header className={"header-section"}>
          {" "}
          <img src={myLogo} className={"header-logo"} alt="Ken's logo" />{" "}
          <nav className={"nav-bar"}>
            {/* <a
            href={"#about-me"}
            // data-aos="fade-right"
            className={"nav-link"}>
            About
          </a> */}
            <a
              href={"#works"}
              // data-aos="fade-right"
              className={"nav-link"}>
              Projects
            </a>
            <a
              href={"#contact"}
              // data-aos="fade-right"
              className={"nav-link"}>
              Contact
            </a>
          </nav>
        </header>
        <div className={"banner-content-wrapper"}>
          <section
            className={"banner-content"}
            // data-aos="fade-left"
          >
            <h1
              id={"title"}
              // data-aos="fade-left"
            >
              {" "}
              {/* For the <b className={"love"}>💖</b> of <br /> Frontend{" "} */}
              Software Developer
            </h1>
            <p className={"about-me"} id={"about-me"}>
              Experienced Frontend Developer with a proven track record of
              delivering exceptional user experiences. Proficient in frontend
              technologies such as HTML5, CSS3, React, TypeScript, and NextJs
              with expertise in designing and developing scalable web
              applications. Skilled in writing test cases, conducting manual and
              automated testing, and identifying defects to ensure the highest
              standards of quality. Adept at collaborating with cross-functional
              teams to deliver projects on time and within budget. Passionate
              about leveraging technology to drive innovation and enhance user
              satisfaction.
            </p>
            <button
              // data-aos="fade-left"
              className={"cta"}
              onClick={handleClick}>
              Get in touch
            </button>

            {/* <a
            href={myCV}
            className={"download-btn"}
            download="Simeon_kenneth_resume">
            Download resume
          </a> */}
          </section>
          <div
            className={"user-img-wrapper"}
            // data-aos="fade-in"
          >
            {/* <img src={logo} className={"user-img"} /> */}
          </div>
        </div>
      </StyledSectionContainer>
    </div>
  );
};

export default Header;
